module.exports = __webpack_public_path__ + "img/resource-tech-image-08.d49efcc2.jpg";